import { WorkflowStageSearchRequest } from "lib/generated/app-service-gql/graphql";
import { CurrentUserData } from "lib/hooks/api/users/useCurrentUser";
import { AssigneeFilterValue } from "../form_components/dropdown_list_selects/UserDropdownFilter";

export type PipelineFilters = {
  teamIds?: string[];
  assignee?: AssigneeFilterValue;
  stageIds?: string[];
};

/** Build lead defaults using the authenticated user at call-time. */
export function getDefaultLeadPipelineFilters(currentUser: CurrentUserData): PipelineFilters {
  return {
    assignee: {
      ids: [currentUser.guid],
      includeNulls: false,
    },
    teamIds: [],
  };
}

/** Build bid defaults at call-time. */
export function getDefaultBidPipelineFilters(): PipelineFilters {
  return {
    assignee: {
      ids: [],
      includeNulls: false,
    },
    stageIds: [],
    teamIds: [],
  };
}

export function convertFiltersToStageFilterRequest(
  filters: PipelineFilters,
): WorkflowStageSearchRequest {
  let assignee: WorkflowStageSearchRequest["assignee"];
  if (filters.assignee && (filters.assignee.ids.length > 0 || filters.assignee.includeNulls)) {
    assignee = filters.assignee;
  }
  return { assignee, teamIds: filters.teamIds };
}
